import React from "react";

/**
 * App mode when the sign-in read failed for a reason other than a rejected
 * session (#9163): the server or the network. The session still stands, so
 * the app is not told to sign out; the page offers the read again.
 */
const AppShellUnavailable: React.FC<{ onRetry: () => void }> = ({
  onRetry,
}) => (
  <div className="flex h-full w-full items-center justify-center bg-white p-8">
    <div className="flex max-w-sm flex-col items-center gap-4 text-center">
      <div className="text-base font-semibold text-[#10141B]">
        Couldn't reach Finpilot
      </div>
      <button
        type="button"
        onClick={onRetry}
        className="cursor-pointer rounded-md bg-gray-800 px-4 py-2 text-sm text-white hover:bg-gray-700"
      >
        Try again
      </button>
    </div>
  </div>
);

export default AppShellUnavailable;
